import { Space, Table, Button, Flex, Select, Row, Col, Statistic, Dropdown, DatePicker } from 'antd';
import { formatCurrency } from 'utils/number';
import { formatOnlyDate } from 'utils/date';
import AddDebt from 'components/debt/AddDebt';
import AddPayment from 'components/debt/AddPayment';
import PaymentDetail from 'components/debt/PaymentDetail';
import dayjs from 'dayjs';

const pdfMenuItems = [
  { key: 'share_pdf', label: 'Share file' },
  { key: 'copy_pdf', label: 'Copy file' },
];

const DebtDesktop = ({
  lstDebtFilled,
  updateDebt,
  debtFilter,
  debt,
  customer,
  onChange,
  showUpdateDebt,
  closeUpdateDebt,
  printDebt,
  onMenuClick,
  setFilterType,
  setFilterStart,
}) => {
  const columns = [
    {
      title: 'Ngày',
      render: (record) => (
        <Space direction="vertical">
          {record.type === 'payment' ? (
            <Button type="link" onClick={() => showUpdateDebt(record.id)}>
              {formatOnlyDate(record.date)}
            </Button>
          ) : (
            <Button type="text">{formatOnlyDate(record.date)}</Button>
          )}
        </Space>
      ),
    },
    {
      title: 'Nội dung',
      render: (record) => <div>{record.description}</div>,
    },
    {
      title: 'Số tiền',
      render: (record) => formatCurrency(record.amount),
    },
  ];

  return (
    <>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Row>
          <Col span={24}>
            <Flex justify="flex-end">
              <div>
                <label>Từ ngày: </label>
                <DatePicker
                  showNow={false}
                  value={debtFilter.start}
                  onChange={setFilterStart}
                  presets={[
                    { label: 'Từ lần thanh toán gần đây', value: dayjs(customer.debt?.last_payment_date).startOf('day') },
                    { label: 'Từ ngày sạch nợ', value: dayjs(customer.debt?.zero_debt_date).startOf('day') },
                    { label: '1 tháng trước', value: dayjs().add(-1, 'month').startOf('day') },
                    { label: '2 tháng trước', value: dayjs().add(-2, 'month').startOf('day') },
                    { label: '3 tháng trước', value: dayjs().add(-3, 'month').startOf('day') },
                  ]}
                />
              </div>
            </Flex>
          </Col>
          <Col span={6}><Statistic title="Đầu kỳ" value={formatCurrency(debt.begin)} /></Col>
          <Col span={6}><Statistic title="Mua mới" value={formatCurrency(debt.debt)} /></Col>
          <Col span={6}><Statistic title="Thanh toán" value={formatCurrency(debt.payment)} /></Col>
          <Col span={6}><Statistic title="Còn nợ" value={formatCurrency(debt.remain)} /></Col>
        </Row>

        <Flex justify="flex-end" style={{ width: '100%' }}>
          <Space>
            <Select
              style={{ width: 150 }}
              value={debtFilter.type}
              onChange={setFilterType}
              options={[
                { value: 'debt', label: 'Ghi nợ' },
                { value: 'payment', label: 'Thanh toán' },
                { value: 'all', label: 'Tất cả' },
              ]}
            />
            <AddPayment onSaved={onChange} customer_id={customer.id} />
            <AddDebt onSaved={onChange} customer_id={customer.id} />
            <Dropdown.Button
              type="primary"
              onClick={printDebt}
              menu={{ items: pdfMenuItems, onClick: onMenuClick }}
            >
              Tải xuống PDF
            </Dropdown.Button>
          </Space>
        </Flex>

        <Table dataSource={lstDebtFilled} columns={columns} scroll={{ y: 300 }} />
      </Space>

      <PaymentDetail
        onSaved={onChange}
        open={updateDebt.isShow}
        id={updateDebt.id}
        onClose={closeUpdateDebt}
      />
    </>
  );
};

export default DebtDesktop;
